// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestLabel {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }
    private _TestLabel?: vf.gui.Label;
    private _buttonList: vf.gui.Label[] = [];

    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {



        document.oncontextmenu = function () { return false; };
        const basicText = this._TestLabel = new vf.gui.Label();
        const mouse = new vf.gui.Interaction.ClickEvent(basicText, true, true);
        basicText.on(vf.gui.Interaction.TouchMouseEvent.onClick, () => {
            console.log('click');
        });
        basicText.on(vf.gui.Interaction.TouchMouseEvent.onRightDown, () => {
            console.log('rigthdown');
        })
        // basicText.style.textAlign !== "center";
        // basicText.style.fontFamily = ["Arial", "Arial"];
        // setTimeout(() => {
        //     console.error(" basicText.style", basicText.style.fontFamily);
        // }, 2000);

        // basicText.style.wordWrap = true;
        // basicText.style.dropShadowColor = 0xffcc00;
        // basicText.style.dropShadow = true;
        // basicText.style.dropShadow=true;
        // basicText.resolution=120;

        basicText.id = 'aaaaa1';
        basicText.width = 300;
        basicText.style.left = 600;
        basicText.style.top = 250;
        basicText.style.letterSpacing = 0;
        basicText.style.lineHeight = 0;
        basicText.style.fontSize = 30;
        basicText.style.textDecoration = 'UnderLine';
        basicText.style.backgroundColor = 0xffffcc;

        basicText.text = "Basic text in vf-gui 33434Basic text in vf-gui 33434   1143434dfgfd 2342424"
        uiStage.addChild(basicText);

        this.getButton('设置/取消text', () => {
            if (basicText.text !== "Hello World") {
                basicText.text = "Hello World";

            } else {
                basicText.text = "Basic text in vf-gui 33434";
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消color', () => {
            if (basicText.style.color !== 0xffcc00) {
                basicText.style.color = 0xffcc00;

            } else {
                basicText.style.color = 0xffffff;
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消letterSpacing', () => {
            if (basicText.style.letterSpacing !== 6) {
                basicText.style.letterSpacing = 6;

            } else {
                basicText.style.letterSpacing = 0;
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消wordWrap', () => {
            if (basicText.style.wordWrap !== true) {
                basicText.style.wordWrapWidth = 100;
                basicText.style.wordWrap = true;

            } else {
                basicText.style.wordWrap = false;
                basicText.style.wordWrapWidth = NaN;

            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消wordWrapWidth', () => {
            if (basicText.style.wordWrapWidth !== 1) {

                basicText.style.wordWrapWidth = 1;
                basicText.style.wordWrap = true;

            } else {
                basicText.style.wordWrap = false;
                basicText.style.wordWrapWidth = NaN;

            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消textAlign==left', () => {
            if (basicText.style.textAlign !== "left") {

                basicText.style.textAlign = "left";
                basicText.style.wordWrapWidth = 100;
                basicText.style.wordWrap = true;

            } else {
                basicText.style.textAlign = "center";
                basicText.style.wordWrap = false;
                basicText.style.wordWrapWidth = NaN;

            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消textAlign==right', () => {
            if (basicText.style.textAlign !== "right") {

                basicText.style.textAlign = "right";
                basicText.style.wordWrapWidth = 100;
                basicText.style.wordWrap = true;

            } else {
                basicText.style.textAlign = "center";
                basicText.style.wordWrap = false;
                basicText.style.wordWrapWidth = NaN;

            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消lineHeight', () => {
            if (basicText.style.lineHeight !== 90) {

                basicText.style.lineHeight = 90;
                basicText.style.wordWrap = true;
                basicText.style.wordWrapWidth = 100;
                basicText.style.wordWrap = true;

            } else {
                basicText.style.lineHeight = 0;
                basicText.style.wordWrap = false;
                basicText.style.wordWrapWidth = undefined;

            }

        }, uiStage, 15, 0);
        let b = 0;
        this.getButton('设置/取消fontFamily', () => {
            b++;
            if (b % 2 === 0) {

                basicText.style.fontFamily = ["宋体", "Arial"];


            } else {
                basicText.style.fontFamily = ["Arial", "宋体"];
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消fontSize', () => {
            if (basicText.style.fontSize !== 30) {

                basicText.style.fontSize = 30;


            } else {
                basicText.style.fontSize = 22;

            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消fontStyle是否为italic', () => {
            if (basicText.style.fontStyle !== "italic") {

                basicText.style.fontStyle = "italic";


            } else {
                basicText.style.fontStyle = "normal";

            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消fontStyle是否为oblique', () => {
            if (basicText.style.fontStyle !== "oblique") {

                basicText.style.fontStyle = "oblique";


            } else {
                basicText.style.fontStyle = "normal";

            }

        }, uiStage, 15, 0);



        this.getButton('设置/取消fontVariant是否为small-caps', () => {
            if (basicText.style.fontVariant !== "small-caps") {

                basicText.style.fontVariant = "small-caps";


            } else {
                basicText.style.fontVariant = "normal";

            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消fontWeight为blod', () => {
            if (basicText.style.fontWeight !== vf.gui.Enum.FontWeight.bold) {

                basicText.style.fontWeight = vf.gui.Enum.FontWeight.bold;


            } else {
                basicText.style.fontWeight = vf.gui.Enum.FontWeight.normal;

            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消fontWeight为bolder', () => {
            if (basicText.style.fontWeight !== vf.gui.Enum.FontWeight.bolder) {

                basicText.style.fontWeight = vf.gui.Enum.FontWeight.bolder;


            } else {
                basicText.style.fontWeight = vf.gui.Enum.FontWeight.normal;

            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消fontWeight为lighter', () => {

            if (basicText.style.fontWeight !== vf.gui.Enum.FontWeight.lighter) {


                basicText.style.fontWeight = vf.gui.Enum.FontWeight.lighter;


            } else {
                basicText.style.fontWeight = vf.gui.Enum.FontWeight.normal;

            }

        }, uiStage, 15, 0);







        this.getButton('设置/取消padding', () => {

            if (basicText.style.padding == 16) {


                basicText.style.padding = 16;


            } else {
                basicText.style.padding = 0;

            }

        }, uiStage, 15, 0);

        this.getButton('设置镂空/填充stroke', () => {

            console.log("basicText.style.color", basicText.style.color);
            if (basicText.style.strokeThickness !== 1) {
                // 空心字 | 镂空字
                basicText.style.strokeThickness = 1; // 描边宽度
                basicText.style.stroke = [0, 255, 0, 1]; // 设置文字描边颜色
                basicText.style.fillColor = []; // 不填充文字内部颜色
            } else {
                basicText.style.strokeThickness = 2;
                basicText.style.stroke = [0, 255, 0, 1];
                basicText.style.fillColor = [255, 0, 0, 1];

                setTimeout(() => {
                    basicText.style.stroke = [0, 255, 0, 0.5];
                    basicText.style.fillColor = [255, 0, 0, 0.7];
                }, 1000);
            }

        }, uiStage, 15, 0);

        this.getButton('设置水平/垂直渐变fillGradientType', () => {

            basicText.text = "三个字三个字";
            console.log("basicText.style.color", basicText.style.color);
            if (basicText.style.fillGradientType !== 0) {
                basicText.style.fillGradientType = 0;
                basicText.style.fillGradientStops = [0, 0.5, 0.5, 1] // 渐变分布
                basicText.style.fillColor = [[255, 0, 0, 1], [0, 255, 0, 1], [0, 0, 255, 1], [0, 0, 0, 1]];

            } else {
                basicText.style.fillGradientType = 1
                basicText.style.fillGradientStops = [0, 0.5, 0.5, 1] // 渐变分布
                basicText.style.fillColor = [[255, 0, 0, 1], [0, 255, 0, 1], [0, 0, 255, 1], [0, 0, 0, 1]];

            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消strokeThickness', () => {

            if (basicText.style.strokeThickness !== 4) {


                basicText.style.strokeThickness = 4;


            } else {
                basicText.style.strokeThickness = 2;

            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消dropShadow', () => {

            if (basicText.style.dropShadow !== true) {

                basicText.style.dropShadow = true;

            } else {
                basicText.style.dropShadow = false;

            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消dropShadowDistance', () => {

            if (basicText.style.dropShadowDistance !== 10) {




                basicText.style.dropShadowDistance = 10;


            } else {
                basicText.style.dropShadowDistance = 5;

            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消dropShadowAlpha', () => {

            if (basicText.style.dropShadowAlpha !== true) {

                basicText.style.dropShadowAlpha = true;

            } else {
                basicText.style.dropShadowAlpha = false;
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消dropShadowAngle', () => {

            if (basicText.style.dropShadowAngle !== 45) {

                basicText.style.dropShadowAngle = 45;





            } else {
                basicText.style.dropShadowAngle = 0;
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消dropShadowBlur', () => {

            if (basicText.style.dropShadowBlur !== 12) {

                basicText.style.dropShadowBlur = 12;





            } else {
                basicText.style.dropShadowBlur = 0;
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消dropShadowColor', () => {

            if ((basicText.style.dropShadowColor as number[])[0] === 255) {

                basicText.style.dropShadowColor = [0, 0, 0, 0.2];

            } else {
                basicText.style.dropShadowColor = [255, 255, 255, 1];
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消breakWords', () => {
            basicText.text = "asdsad apple 苹果 sadadsad"
            if (basicText.style.breakWords !== false) {

                basicText.style.breakWords = false;

            } else {

                basicText.style.breakWords = true;
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消textDecoration', () => {

            if (basicText.style.textDecoration != 'Overline') {

                basicText.style.textDecoration = 'Overline';

            } else {

                basicText.style.textDecoration = 'None';
            }

        }, uiStage, 15, 0);



        this.getButton('设置/取消textDecorationColor', () => {

            if (basicText.style.textDecorationColor != 0xffcc00) {

                basicText.style.textDecorationColor = 0xffcc00;

            } else {

                basicText.style.textDecorationColor = 0x000000;
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消textAlpha', () => {

            if (basicText.textAlpha != 1) {

                basicText.textAlpha = 1;

            } else {

                basicText.textAlpha = 0;
            }

        }, uiStage, 15, 0);


        // this.getButton('设置/取消linearGradientType', () => {

        //     if ( basicText.style.linearGradientType!= 'horizontal') {

        //         basicText.style.linearGradientType='horizontal';

        //     } else {

        //         basicText.style.linearGradientType='vertical';
        //     }

        // }, uiStage, 15, 0);



        function hoverFun3() {
            basicText.style.left += 60;
            basicText.style.top += 50;
        }


        let b3 = false;
        const btn3 = this.getButton('设置/取消CHANGE事件', () => {

            if (!b3) {

                b3 = true;
                basicText.off(vf.gui.Interaction.ComponentEvent.CHANGE, hoverFun3);

            } else {
                b3 = false;
                basicText.on(vf.gui.Interaction.ComponentEvent.CHANGE, hoverFun3);
                // basicText.style.left = 600;
                // basicText.style.top = 250;
            }
            basicText.text += "1";

        }, uiStage, 15, 0);

        const text = new vf.Text("音频测试PC端", {
            // fontFamily: 'Arial',
            fontSize: 40,
            // fontStyle: 'italic',
            // fontWeight: 'bold',
            fill: undefined,
            stroke: '#4a1850',
            strokeThickness: 1,
            // dropShadow: true,
            // dropShadowColor: '#000000',
            // dropShadowBlur: 4,
            // dropShadowAngle: Math.PI / 6,
            // dropShadowDistance: 6,
            // wordWrap: true,
            // wordWrapWidth: 440,
        });
        text.x = 10;
        text.y = 30;
        uiStage.container.addChild(text);

        // const canvas = document.createElement("canvas");
        // canvas.width = 100;
        // canvas.height = 100;
        // document.body.appendChild(canvas);
        // const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
        // ctx.font = '48px serif';
        // ctx.strokeText('Hello world 你好，事件', 10, 50);

    }



    private posY = 15;
    private getButton(title: string, clickFun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 15;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, clickFun);
        target.addChild(button);
        this.posY = this.posY + 15 + y;
        this._buttonList.push(button);
        return button;
    }


    private onRelease() {
        if (this._TestLabel) {
            this._TestLabel.removeAllListeners();
            this._TestLabel.parent && this._TestLabel.parent.removeChild(this._TestLabel);
            this._TestLabel.release();
            this._TestLabel = undefined;
        }

        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }




}
